import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';
import moment from 'moment';

import styled from 'styled-components';
import { COLORS, FlexView } from '@cuemath/comps';

import { get as getListCount } from 'actions/list-count';
import { getAll as getClassList } from 'actions/teacher-classroom-list';
import { openModal } from 'actions/modal';

import ClassroomList from './list';
import Pagination from 'modules/list/pagination';
import Search from 'modules/list/search-bar';

import { RESULTS_PER_PAGE } from 'constants/list';
import { RESOURCE_URL } from 'constants/api';

const FullFlexView = styled(FlexView)`
  width: 100%;
`;

const Head = styled(FlexView)`
  width: 100%;
  padding-left: 15px;
  padding-right: 20px;
  gap: 10px;
`;

const SearchError = styled.div`
  width: 500px;
  padding: 4px 15px;
  border-radius: 16px;
  background: ${COLORS.RED_SHADE};
  color: ${COLORS.WHITE};
`;

class TeacherClassroomsTab extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      searchKey: null,
      listData: null,
      countData: null,
      filterParam: null,
      searchError: null,
    };
  }

  static getDerivedStateFromProps({ teacherClassroomList, listCount }, { page }) {
    const listParams = { page, per_page: RESULTS_PER_PAGE };
    const countParams = { count: true };

    return {
      listData: store.getAll(teacherClassroomList, listParams),
      countData: store.get(listCount, RESOURCE_URL.teacherClassroomList, countParams),
    };
  }

  componentDidMount() {
    const { actions } = this.props;
    const { page } = this.state;
    const listParams = { page, per_page: RESULTS_PER_PAGE };
    const filterData = { page, per_page: RESULTS_PER_PAGE };
    const countParams = { count: true };
    const countFilterParams = { count: true, page, per_page: RESULTS_PER_PAGE };

    actions.getClassList(listParams, filterData);
    actions.getListCount(
      RESOURCE_URL.teacherClassroomList,
      countParams,
      countFilterParams,
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { actions } = this.props;
    const { page, searchKey, filterParam } = this.state;
    const listParams = { page, per_page: RESULTS_PER_PAGE };
    const countParams = { count: true };
    const filterData = { page, per_page: RESULTS_PER_PAGE };
    const countFilterParams = { count: true, page, per_page: RESULTS_PER_PAGE };
    const isValidPhoneNumber = searchKey && searchKey.length === 10;

    if (isValidPhoneNumber) {
      //* Assigning same value to multiple variable. `searchKey` is the value.
      filterData.phone = countFilterParams.phone = searchKey;
    }

    if (
      (prevState.searchKey !== searchKey && isValidPhoneNumber) ||
      filterParam !== prevState.filterParam ||
      prevState.page !== page
    ) {
      if (filterParam) {
        filterParam.forEach(filter => {
          let value = filter.value;
          const key = filter.id;

          if (value && Array.isArray(value) && value.length) {
            filterData[key] = value;
            countFilterParams[key] = value;
          } else {
            if (value !== null) {
              const newValue =
                key === 'date' ? moment(value, 'YYYY-MM-DD').unix() : value;
              filterData[key] = newValue;
              countFilterParams[key] = newValue;
            }
          }
        });
      }
      actions.getClassList(listParams, filterData);
      actions.getListCount(
        RESOURCE_URL.teacherClassroomList,
        countParams,
        countFilterParams,
      );
    }
  }

  onPageChange = newPage => {
    this.setState({ page: newPage });
  };

  onFilter = filters => {
    this.setState({ filterParam: filters });
  };

  onSearch = searchKey => {
    const { searchKey: stateSearchKey } = this.state;
    const canSearch = searchKey !== stateSearchKey && (stateSearchKey || searchKey);
    const hasSearchError = searchKey && searchKey.length !== 10;

    if (canSearch) this.setState({ searchKey: searchKey, searchError: hasSearchError });
  };

  render() {
    const { page, searchError, listData, countData } = this.state;

    return (
      <FullFlexView justifyContent="center" alignItems="center">
        <Head justifyContent="center" alignItems="flex-start">
          <Search
            type="number"
            disableSteps
            onSearch={this.onSearch}
            placeholder="Phone number..."
          />
          {searchError && <SearchError>Phone number should be of 10 digit.</SearchError>}
        </Head>
        <ClassroomList
          tableData={!!listData ? listData.data : []}
          page={page}
          onFilter={this.onFilter}
        />
        <Pagination
          page={page}
          perPage={RESULTS_PER_PAGE}
          count={!!countData ? countData.data : 0}
          onPageChange={this.onPageChange}
        />
      </FullFlexView>
    );
  }
}

export default connect(
  ({ teacherClassroomList, listCount }) => ({ teacherClassroomList, listCount }),
  dispatch => ({
    actions: bindActionCreators(
      {
        getListCount,
        getClassList,
        openModal,
      },
      dispatch,
    ),
  }),
)(TeacherClassroomsTab);
